import { Pipe, PipeTransform } from '@angular/core';
import { Account } from '../models/account';
@Pipe({
    name: 'accountDisplay'
})
export class AccountDisplay implements PipeTransform {
    transform(account?: Account): any {
        if (account) {
           return account.code + ' - ' + account.name + ' - ' + account.address.city;
        }
        return account;
    }
}
